import React from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';
import { DataTestId } from 'types/general.types';

export const ListItem: React.FC<DataTestId & FlexProps> = ({
  children,
  ...rest
}) => (
  <Flex position="relative" height="full" alignItems="center" {...rest}>
    {children}
  </Flex>
);
